import { useQuery } from "@tanstack/react-query";
import { Province } from "@vw-marketing/vw-ca-types";
import { useContext } from "react";
import { LocationContext } from "../app";
import { getLang } from "../trans";
import { useFeatureServices } from "../use-feature-services";
import { fetchVehicles } from "./fetchVehicles";

const useVehiclesQuery = (acodes: string[], enabledAtInit?: boolean) => {
  const serviceConfig = useFeatureServices()["service-config-provider"].configs['compare-tool-api'];

  if (!serviceConfig) {
    throw new Error("Service configuration for 'compare-tool-api' is not defined");
  }

  const province = useContext(LocationContext) as Province;

  const lang = getLang();

  const { urlOrigin, urlPath } = serviceConfig;
  const baseUrl = `${urlOrigin}${urlPath}`;

  const enabled = !!acodes?.length && enabledAtInit && !!province;


  const vehiclesQuery = useQuery({
    queryKey: ['vehicles', baseUrl, acodes],
    queryFn: () => fetchVehicles(baseUrl, lang, acodes, province),
    select: (data) => data?.data,
    enabled
  });

  return vehiclesQuery;
};

export default useVehiclesQuery;
